module.exports = __webpack_public_path__ + "img/person-criticle.ebaeb7b2.svg";